// NATIVE 
import React, { useState } from 'react';


// INSTALLED 
import Box from '@mui/material/Box';
import { Formik, Form } from 'formik';
import Step from '@mui/material/Step';
import Stepper from '@mui/material/Stepper';
import StepLabel from '@mui/material/StepLabel';
import { Card, Divider } from '@mui/material';



// CUSTOM 
import { mtDividerUpTable } from '../../commons';
import { DatosBasicosDetalle } from '../../components/empresa/detalle';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import validationSchema from '../../components/empresa/editar/formModels/validationSchema';
import formInitialValues from '../../components/empresa/editar/formModels/formInitialValues';





/**
 * DetalleCompania component renders the detailed view of a company.
 * It includes a breadcrumb navigation, a stepper for navigation through different steps,
 * and a form managed by Formik for handling form state and validation.
 *
 * @component
 * @example
 * return (
 *   <DetalleCompania />
 * )
 *
 * @returns {JSX.Element} The rendered component.
 *
 * @remarks
 * - The component uses Material-UI for layout and styling.
 * - The form validation schema is dynamically selected based on the active step.
 * - The steps array currently contains only one step: 'Detalles Informacion Compañia'.
 *
 * @hook
 * - useState: Manages the active step in the stepper.
 *
 * @dependencies
 * - Formik: For form state management and validation.
 * - Material-UI: For UI components like Box, Divider, Stepper, Step, StepLabel, and Card.
 * - BreadCrumbsAndTitle: Custom component for breadcrumb navigation and title display.
 * - DatosBasicosDetalle: Custom component rendered as the content of the first step.
 */
export const DetalleCompania = () => {

  // USE STATE 
  const [activeStep, setActiveStep] = useState(0);

  // DATA MODEL 
  const currentValidationSchema = validationSchema[activeStep];
  

  const steps: string[] = ['Detalles Informacion Compañia'];


  

  const  _renderStepContent = (steps: any) => {
    switch (steps) {
      case 0:
        return <DatosBasicosDetalle/>;
      default:
        return <div>View Or Page Not Found</div>; 
    }
  }




  return (



    <Box sx={{ width: '100%' }}>
     
      

      <BreadCrumbsAndTitle 
                title="Detalle Compañia" 
                mainModule="configuracion" 
                parent="Detalle Compañia"
                action="/configuracion/compania" />

      <Divider sx={{ marginBottom: mtDividerUpTable }}/>
           
      
      
      <Stepper activeStep={activeStep}>
        {steps.map((label:any, index:any) => {
          const labelProps: {
            optional?: React.ReactNode;
            error?: boolean;
          } = {};

          return (
            <Step key={label}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>

         <Formik
            initialValues={formInitialValues}
            validationSchema={currentValidationSchema}
            onSubmit={ () => console.log() }
          >
         <Card style={{ marginTop: 50,  padding: 20}}>
           <Form id={'formId'}>
             {_renderStepContent(activeStep)}
            </Form>
         </Card>
         
         </Formik>
    </Box>
  )
}
